(function () {
  var root = document.querySelector('.lookpage');
  if (!root) return;

  var items = root.querySelectorAll('.side-item');
  var panels = root.querySelectorAll('.market-panel');

  var PANELS = ['looks', 'brands', 'styles'];
  function show(p) {
    if (PANELS.indexOf(p) < 0) p = 'looks';
    items.forEach(function (x) { x.classList.toggle('on', x.dataset.panel === p); });
    panels.forEach(function (pl) { pl.classList.toggle('is-active', pl.dataset.panel === p); });
    root.classList.toggle('view-styles', p === 'styles');
    root.classList.toggle('view-looks', p === 'looks');
  }
  items.forEach(function (it) { it.addEventListener('click', function () { show(it.dataset.panel); closeDrawer(); }); });
  function panelFromHash() { return (location.hash || '').replace('#', '').toLowerCase(); }
  show(panelFromHash() || 'looks');
  window.addEventListener('hashchange', function () { show(panelFromHash() || 'looks'); });

  // styles: category filter — desktop sidebar + mobile drawer share .cat-row buttons
  var cats = root.querySelectorAll('.cat-row');
  var grid = document.getElementById('prod-grid');
  var empty = document.getElementById('prod-empty');
  function hasCat(card, cat) {
    if (!cat) return true;
    return (' ' + (card.getAttribute('data-cat') || '') + ' ').indexOf(' ' + cat + ' ') > -1;
  }
  var scatMenu = document.getElementById('scat-menu');
  function openDrawer() { document.body.classList.add('arx-menu-open'); if (scatMenu) scatMenu.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { document.body.classList.remove('arx-menu-open'); if (scatMenu) scatMenu.setAttribute('aria-hidden', 'true'); }
  var scatBurger = document.getElementById('scat-burger');
  var scatScrim = document.getElementById('scat-scrim');
  var scatClose = document.getElementById('scat-close');
  if (scatBurger) scatBurger.addEventListener('click', openDrawer);
  if (scatScrim) scatScrim.addEventListener('click', closeDrawer);
  if (scatClose) scatClose.addEventListener('click', closeDrawer);

  cats.forEach(function (c) {
    c.addEventListener('click', function () {
      var cat = c.getAttribute('data-cat') || '', shown = 0;
      cats.forEach(function (x) { x.classList.toggle('on', (x.getAttribute('data-cat') || '') === cat); });
      if (grid) grid.querySelectorAll('.prod-card').forEach(function (card) {
        var ok = hasCat(card, cat);
        card.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
      show('styles');
      closeDrawer();
    });
  });

  // ---- build-a-fit: each slot cycles its real products; "add fit to cart" adds the current set ----
  var slots = Array.prototype.slice.call(root.querySelectorAll('.fitb-slot'));
  slots.forEach(function (slot) {
    var stage = slot.querySelector('[data-fitb-stage]');
    var slotItems = stage ? Array.prototype.slice.call(stage.querySelectorAll('.fitb-item')) : [];
    if (!slotItems.length) { slot.classList.add('is-empty'); return; }
    // shuffle the whole deck each load (Fisher–Yates): the first piece AND the
    // browse order are random — never the collection's fixed sequence
    for (var s = slotItems.length - 1; s > 0; s--) {
      var j = Math.floor(Math.random() * (s + 1));
      var tmp = slotItems[s]; slotItems[s] = slotItems[j]; slotItems[j] = tmp;
    }
    var i = 0;  // position 0 of a shuffled deck — already random
    function render() { slotItems.forEach(function (el, k) { el.classList.toggle('on', k === i); }); }
    slot.querySelectorAll('.fitb-arrow').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.classList.contains('next') ? 1 : -1;
        i = (i + dir + slotItems.length) % slotItems.length;
        render();
      });
    });
    render();
  });

  var fitCart = document.getElementById('fitb-cart');
  if (fitCart) {
    var fitOriginal = fitCart.textContent;
    var fitTimer = null;
    function fitMsg(txt, revertMs) {
      clearTimeout(fitTimer);
      fitCart.textContent = txt;
      if (revertMs) fitTimer = setTimeout(function () { fitCart.textContent = fitOriginal; }, revertMs);
    }
    function refreshCartCount() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.top .cart b').forEach(function (b) { b.textContent = '(' + c.item_count + ')'; });
        document.querySelectorAll('.mhd-n').forEach(function (b) { b.textContent = c.item_count; });
      }).catch(function () { /* count refresh is best-effort */ });
    }
    fitCart.addEventListener('click', function () {
      if (fitCart.disabled) return;
      // read what's actually on screen AT CLICK TIME: the .on item in each slot's stage.
      // (never a cached index or the first item — this is what keeps display and cart in sync)
      var ids = [];
      slots.forEach(function (s) {
        var stage = s.querySelector('[data-fitb-stage]');
        var on = stage ? stage.querySelector('.fitb-item.on') : null;
        var vid = on ? parseInt(on.getAttribute('data-vid'), 10) : NaN;
        if (!isNaN(vid) && vid > 0) ids.push(vid);  // empty slots / missing vids are skipped
      });
      if (!ids.length) { fitMsg('nothing to add', 1500); return; }
      // ONE request with an items array — no sequential per-slot calls to race or drop
      var payload = ids.map(function (id) { return { id: id, quantity: 1 }; });
      fitCart.disabled = true;
      fitMsg('adding the fit…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payload })
      }).then(function (r) {
        // /cart/add.js answers 422 (e.g. variant sold out since render) with a JSON body —
        // the old code ignored r.ok and "succeeded" into an unchanged cart
        if (!r.ok) return r.json().then(function (err) { throw new Error(err && err.description || ('add failed: ' + r.status)); });
        return r.json();
      }).then(function () {
        fitCart.disabled = false;
        fitMsg('added ✓', 1500);
        refreshCartCount();
      }).catch(function () {
        fitCart.disabled = false;
        fitMsg("couldn't add — try again", 2200);
      });
    });
  }

  // anonymous "coming soon" brand tiles: tap toggles the reveal (hover/focus handled by CSS)
  var anon = root.querySelectorAll('.brand-tile.is-anon');
  anon.forEach(function (tile) {
    tile.addEventListener('click', function () {
      var open = tile.classList.contains('is-open');
      anon.forEach(function (t) { t.classList.remove('is-open'); });
      if (!open) tile.classList.add('is-open');
    });
  });

  // live brand tiles on touch: first tap reveals the name chip, second tap navigates
  if (window.matchMedia('(hover: none)').matches) {
    var liveTiles = root.querySelectorAll('.brand-tile.is-brand');
    liveTiles.forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        if (tile.classList.contains('is-open')) return; // second tap: follow the link
        e.preventDefault();
        liveTiles.forEach(function (t) { t.classList.remove('is-open'); });
        tile.classList.add('is-open');
      });
    });
    // tapping elsewhere closes any open chip
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.brand-tile.is-brand')) {
        liveTiles.forEach(function (t) { t.classList.remove('is-open'); });
      }
    });
  }
})();
